import Web3 from "web3";

let isItConnected = false;

const networks = {
  songbird: {
    chainId: `0x${Number(19).toString(16)}`,
    chainName: "Songbird",
    nativeCurrency: {
      name: "SGB",
      symbol: "SGB",
      decimals: 18,
    },
    rpcUrls: ["https://songbird-api.flare.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://songbird-explorer.flare.network"],
  },
};

const changeNetwork = async (networkName) => {
  try {
    if (!window.ethereum) throw new Error("No crypto wallet found");
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          ...networks[networkName],
        },
      ],
    });
  } catch (err) {
    console.error("Error while changing network: ", err);
  }
};

const handleNetworkSwitch = async (networkName) => {
  await changeNetwork(networkName);
};

const getAccounts = async () => {
  const web3 = window.web3;
  try {
    const accounts = await web3.eth.getAccounts();
    return accounts;
  } catch (error) {
    console.error("Error while fetching accounts: ", error);
    return null;
  }
};

export const disconnectWallet = async () => {
  try {
    await window.ethereum.request({
      method: "wallet_requestPermissions",
      params: [{ eth_accounts: {} }],
    });
    console.log("Disconnected");
  } catch (error) {
    console.error("Error while disconnecting wallet: ", error);
  }
};

export const loadWeb3 = async () => {
  try {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      await window.ethereum.enable();
      let netId = await window.web3.eth.getChainId();

      if (netId.toString() !== "19") {  // Check if not on Songbird network
        alert("You are on the wrong network. Switching to Songbird network.");
        await handleNetworkSwitch("songbird");
        netId = await window.web3.eth.getChainId();
      }

      isItConnected = netId.toString() === "19";

      console.log("isItConnected", isItConnected);

      if (isItConnected) {
        const accounts = await getAccounts();
        return accounts[0];
      } else {
        return "Wrong Network";
      }
    } else {
      return "No Wallet";
    }
  } catch (error) {
    console.error("Error while loading Web3: ", error);
    return "No Wallet";
  }
};
